import { Spin } from "antd"
import { motion } from "motion/react"
import { useState } from "react"

import { ANIMATION_BY_KEY } from "#blocks/AnimateInFlex"
import Flex from "#blocks/Flex"
import { ReactChild } from "#customTypes/globalTypes"

const AnimatedReceiptSection = ({
  width,
  children,
  isOpen,
  isPending = false,
}: {
  width: number
  children: ReactChild
  isOpen: boolean
  isPending?: boolean
}) => {
  const [isAnimating, setIsAnimating] = useState(false)

  if (!isOpen) return null

  return (
    <motion.div
      key="receipt"
      initial={{ width: 0, opacity: 0 }}
      animate={{ width, opacity: 1 }}
      exit={{ width: 0, opacity: 0 }}
      transition={{
        duration: 0.3,
        ease: "easeOut",
        opacity: { duration: 0.2 },
      }}
      style={{
        overflow: "hidden",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flexWrap: isAnimating ? "nowrap" : "wrap",
        flexGrow: 1,
      }}
      onAnimationComplete={() => setIsAnimating(false)}
    >
      {isAnimating ? null : (
        <Flex col style={{ height: "100%", justifyContent: "space-between" }}>
          <Flex col>
            <motion.h2
              key="receipt-header"
              {...ANIMATION_BY_KEY.leftSm}
              style={{
                overflow: "hidden",
                marginBottom: 10,
              }}
            >
              Receipt
            </motion.h2>

            {children}
          </Flex>

          <motion.div
            key="receipt-footer"
            {...ANIMATION_BY_KEY.leftSm}
            style={{
              marginBottom: 10,
              textAlign: "right",
              width,
            }}
          >
            {isPending ? (
              <Flex gap={10}>
                <Spin size="small" /> Sending receipt...
              </Flex>
            ) : (
              "Clicking Submit will email the receipt"
            )}
          </motion.div>
        </Flex>
      )}
    </motion.div>
  )
}

export default AnimatedReceiptSection
